import { FC } from 'react'

import { AssignBuyerButton } from '../AssignBuyerButton/AssignBuyerButton'
import { OrderData } from 'features/Orders/Review/components/Overview/Overview'
import { buyerDataToBuyerId } from 'features/Orders/Review/utils/review.utils'
import { Contact } from 'features/Orders/components/Contacts/Contact'

type Props = {
  buyers: OrderData['buyer'][]
  showAssignBuyerButton?: boolean
  onClickAssignBuyerButton?: () => void
}

export const BuyerList: FC<Props> = ({
  buyers,
  onClickAssignBuyerButton,
  showAssignBuyerButton = false,
}) => (
  <>
    {showAssignBuyerButton ? (
      <AssignBuyerButton onClick={onClickAssignBuyerButton} />
    ) : (
      buyers?.map((buyer: OrderData['buyer']) => (
        <Contact
          title="Buyer"
          key={buyerDataToBuyerId({
            name: buyer?.name || '',
            email: buyer?.email || '',
          })}
          name={buyer?.name || ''}
          email={buyer?.email || ''}
        />
      ))
    )}
  </>
)
